import { auth } from '../firebase/firebase';
import { API_BASE_URL } from './index';

// Set in localStorage after a successful /api/sandbox/complete call so the
// top-of-app countdown badge can compute remaining time without refetching.
export const SANDBOX_EXPIRES_KEY = 'mflow_sandbox_expires_at';

export interface SandboxCompleteResponse {
  success: true;
  sandboxExpiresAt: string;
}

export class SandboxRateLimitError extends Error {
  constructor() {
    super('Too many sandbox requests, try again later.');
    this.name = 'SandboxRateLimitError';
  }
}

export const completeSandbox = async (): Promise<SandboxCompleteResponse> => {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('User not authenticated');
  }
  const token = await user.getIdToken();

  const response = await fetch(`${API_BASE_URL}/api/sandbox/complete`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (response.status === 429) {
    throw new SandboxRateLimitError();
  }

  if (!response.ok) {
    throw new Error('Failed to set up sandbox');
  }

  return response.json();
};
